import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "email",
  "use": "email-usage",
  "viewBox": "0 0 62.9 46.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 62.9 46.3\" id=\"email\"><path class=\"st0\" d=\"M55.9 0H7C3.1 0 0 3.1 0 7v32.3c0 3.8 3.1 7 7 7h49c3.8 0 7-3.1 7-7V7c-.1-3.9-3.3-7-7.1-7zm2.8 39.3c0 1.5-1.3 2.8-2.8 2.8H7c-1.5 0-2.8-1.3-2.8-2.8V7c0-1.5 1.3-2.8 2.8-2.8h49c1.5 0 2.8 1.3 2.8 2.8v32.3z\" /><path class=\"st0\" d=\"M52.3 11.1L31.4 24.2 10.6 11.1c-1-.6-2.3-.3-2.9.7-.6 1-.3 2.3.7 2.9l21.9 13.8c.3.2.7.3 1.1.3h.1c.4 0 .8-.1 1.1-.3l21.9-13.8c1-.6 1.3-1.9.7-2.9-.7-1.1-2-1.4-2.9-.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/email.svg
// module id = i1m2
// module chunks = 6